import { LoadTemplate } from '../rest/load_template';
import { DomParsing } from '../services/dom_parsing';
import { BindingEvent } from '../services/binding_event';
import { ErrorValidation } from '../services/error_validation';
import { RestClient } from '../rest/RestClient';
import { EncryptAndDecrypt } from '../services/encrypt_deccrypt';
import { internalCall, applicationName, FEProcessName, FEProcessGuid, cssApplicationName, } from '../model/itgConfig.model';
import { AxiosClient } from '../rest/AxiosClient';
import { xjsTemplate } from '../services/XJStemplate';
var Transformation = /** @class */ (function () {
    function Transformation(config) {
        var _a, _b, _c;
        this.config = config;
        this.restClient = RestClient.getInstance((_a = this.config) === null || _a === void 0 ? void 0 : _a.restClient, (_b = this.config) === null || _b === void 0 ? void 0 : _b.restClientProvider);
        this.errorValidation = new ErrorValidation();
        this.providerInstance = ((_c = this.config) === null || _c === void 0 ? void 0 : _c.restClientProvider) ? this.config.restClientProvider
            : new AxiosClient();
        this.loadTemplate = LoadTemplate.getInstance(this.restClient, this.providerInstance);
        this.domParsing = new DomParsing();
        this.bindingEvent = new BindingEvent(this.config);
        this.serviceCallResponseData = new Object();
        this.encryptAndDecrypt = new EncryptAndDecrypt(this.config);
        this.returnHTMLOnError = false;
        this.errorValidation.validateSdkConfig(config);
        // this.restClient = RestClient.getInstance(config);
        this.returnHTMLOnError = (config === null || config === void 0 ? void 0 : config.returnHTMLOnError) ? config === null || config === void 0 ? void 0 : config.returnHTMLOnError : false;
    }
    Transformation.prototype.transform = function (request, template, isTemplateAString, isXJS) {
        if (request && request.isQueryAMessage) {
            request.query = this.getQueryParamsFromMessage(request.query);
        }
        else if (request.query && !request.query.stepId) {
            if (!request.query.FEProcessName ||
                !request.query.FEProcessGuid ||
                !request.query.applicationName ||
                !request.query.cssApplicationName) {
                this.updateQueryParams(request);
            }
        }
        if (isTemplateAString) {
            return this.tranformTemplateString(request, template);
        }
        if (isXJS) {
            var funcName = xjsTemplate.prototype.getTemplate();
            template = funcName('');
            return this.tranformTemplateString(request, template);
        }
        else {
            return this.tranformTemplateResponse(request, template);
        }
    };
    // public shouldReturnHTMLOnError (val: boolean) {
    //   this.returnHTMLOnError = val;
    // }
    Transformation.prototype.updateQueryParams = function (request) {
        var _a, _b, _c, _d;
        if (request.query) {
            if (!request.query.FEProcessName) {
                request.query.FEProcessName = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.FEProcessName) || FEProcessName;
            }
            if (!request.query.FEProcessGuid) {
                request.query.FEProcessGuid = ((_b = this.config) === null || _b === void 0 ? void 0 : _b.FEProcessGuid) || FEProcessGuid;
            }
            if (!request.query.applicationName) {
                request.query.applicationName = ((_c = this.config) === null || _c === void 0 ? void 0 : _c.applicationName) || applicationName;
            }
            if (request.query.cssApplicationName === undefined) {
                request.query.cssApplicationName = ((_d = this.config) === null || _d === void 0 ? void 0 : _d.cssApplicationName) || cssApplicationName;
            }
        }
    };
    Transformation.prototype.getQueryParamsFromMessage = function (message) {
        var _a, _b;
        var updatedQueryParam = Object.assign({});
        updatedQueryParam = Object.assign({
            sessionId: message.sessionId,
            stepId: message.stepId,
            internalCall: ((_a = this.config) === null || _a === void 0 ? void 0 : _a.internalCall) || internalCall,
            applicationName: ((_b = this.config) === null || _b === void 0 ? void 0 : _b.applicationName) || applicationName,
        }, message[message.displayFormReferenceKey]);
        if (!updatedQueryParam.displayFormReferenceKey) {
            updatedQueryParam.displayFormReferenceKey = message.displayFormReferenceKey;
        }
        return updatedQueryParam;
    };
    return Transformation;
}());
export { Transformation };
//# sourceMappingURL=Transformation.js.map